import NewsCard from './NewsCard.vue';

export default NewsCard;



// WEBPACK FOOTER //
// ./src/pages/profile/components/news/index.ts